export default __webpack_public_path__ + "static/media/image1.21c6a0a6.jpg";